import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { db, auth } from './firebase';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const snapshot = await getDocs(collection(db, 'users'));
      setUsers(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
      setError(null);
    } catch (err) {
      console.error('Error fetching users:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Firestore rules require a signed-in user, so wait for Firebase to restore
  // the session before fetching (and refetch whenever the user changes).
  useEffect(() => {
    return onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchUsers();
      } else {
        setUsers([]);
        setLoading(false);
      }
    });
  }, [fetchUsers]);

  return (
    <UserContext.Provider value={{ users, setUsers, loading, setLoading, error, fetchUsers }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUsers = () => useContext(UserContext);
